import { BaseBus } from "./BaseBus";
import { GeographyInfoBus } from "./GeographyInfoBus";

export class PotentialLocationBus extends BaseBus
{
    constructor(data: PotentialLocationBus) {
        super(data);
    }

    potentialLocationId: any;
    potentialCustomerId: any;
    potentialLocationName: string;
    quickSearchKey: string;
    isActive: boolean;
    emailAddress: string;
    workNumber: string;
    mobileNumber: string;
    faxNumber: string;
    notes: string;
    insertDt: Date;
    updateDt: Date;
    insertUserId: any;
    updateUserId: any;
    workExt: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateProvince: string;
    postalCode: string;
    countryCd: string;
    geographyInfo: GeographyInfoBus;

}
